// extracted by mini-css-extract-plugin
export default {"FAQMostAsked":"FAQMostAsked_FAQMostAsked__ME++t","answer":"FAQMostAsked_answer__CgP5j"};